import axios from "./request";
const getLocalUserInfo = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user || {};
};
export const HomeInfo = () => {
  return axios.post("/index_information_show");
};
export const newTechShow = () => {
  const data = new FormData();
  data.append("type", 1);
  return axios.post("/new_technique_show", data);
};

export const RawMaterial = () => {
  return axios.post("/raw_material");
};

export const GetSelectMessageIndexList = params => {
  const {
    num,
    page,
    m_type,
    updated_at,
    price,
    title,
    name,
    xq_type,
    sd_type,
    resource_type,
    type,
    created_at,
    status,
    is_end
  } = params;
  const data = new FormData();
  data.append("num", num);
  data.append("page", page);
  data.append("m_type", m_type);
  data.append("title", title || name || "");
  if (m_type == 5) {
    data.append("updated_at", updated_at || "");
    data.append("price", price || "");
  }
  if (m_type == 4) {
    data.append("xq_type", xq_type);
  }
  if (m_type == 3) {
    data.append("sd_type", sd_type);
    data.append("resource_type", resource_type);
  }
  if (m_type == 2) {
    data.append("type", type);
  }
  if (m_type == 6) {
    data.append("status", "2");
  }
  if (m_type == 7) {
    data.append("created_at", created_at);
    data.append("is_end", is_end);
    data.append("status", 2);
  }

  return axios.post("/select_message_index", data);
};

export const PurchaseAdd = data => {
  return axios.post("/purchase_add", { data });
};

export const ApplyAdd = params => {
  const { lid, apply, publish_id } = params;
  const data = new FormData();
  const { id: uid } = getLocalUserInfo();
  data.append("lid", lid);
  data.append("uid", uid);
  data.append("apply", apply);
  data.append("publish_id", publish_id);
  return axios.post("/apply_add", data);
};



// WEBPACK FOOTER //
// ./src/request/home.js